module.exports = __webpack_public_path__ + "static/media/training_3_somatic_exercise.161607de.webp";